import { Pipe, PipeTransform } from '@angular/core';

import { getTimezoneAbbr } from '@utils/timezone-helper';

@Pipe({
  name: 'timezoneAbbreviation',
  standalone: true,
})
export class TimezoneAbbreviationPipe implements PipeTransform {
  transform(timezoneShortName: string): string {
    return getTimezoneAbbr(timezoneShortName);
  }
}
